import { useInView } from "react-intersection-observer";

import Circles from "./Circles";
import HeroName from "./HeroName";
import TimeBox from "./TimeBox";
import { handleGAEvent } from "../helpers/googleAnalytics";

const Hero = () => {
    const scrollToSection = (event: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
        event.preventDefault()
        const section = document.getElementById(sectionId)
        handleGAEvent(`handle_${sectionId}`)
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' })
        }
    }
    const {ref, inView} = useInView({
        triggerOnce: true,
        rootMargin: '0px 0px',
    })

  return (
    <div className="hero-container" ref={ref}>
        <div className={`header-container container ${!!inView && 'in-view'}`}>
            <TimeBox/>
            <div className="header-links">
                <a href="#about" onClick={(e) => scrollToSection(e, 'about')}>ABOUT</a>
                <a href="#work" onClick={(e) => scrollToSection(e, 'work')} >WORK</a>
                <a href="/camila_sanchez_vinik_resume.pdf" download="camila_sanchez_vinik_resume.pdf" onClick={() => handleGAEvent('download_resume')}>RESUME</a>
            </div>
            <div className="header-cta">
                <a href="https://calendar.app.google/Nt4BTmPCNJvfy2Hw8" onClick={() => handleGAEvent('wanna_talk')} target="_blank">
                    WANNA TALK?
                </a>
            </div>
        </div>

        <HeroName/>

        <div className={`hero-footer-container container ${!!inView && 'in-view'}`}>
            <div className="hero-footer-content container">
                <div className="role">SOFTWARE ENGINEER</div>
                <div className="company"><span>CURRENTLY</span><div>@EVERPASS</div></div>
            </div>
            <Circles/>
        </div>
    </div>
  );
};

export default Hero;